// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3FmFA","amount":"Amount_amount__1SWP6","tip":"Amount_tip__2Mnyi","tipHeader":"Amount_tipHeader__-ofM9","tipsWrap":"Amount_tipsWrap__1xc6M"};